import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
import { useSoFormStepsApi } from 'refactored/features/soForm/SoForm.context';
//
import { useTranslation } from 'react-i18next';

const LoadTypeSelector = styled.div`
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 0px;
  gap: 12px;

  width: 50%;

  height: 48px;

  /* grey / 100 */

  background: var(--white);
  /* grey / 300 */

  border: 1px solid #ccd6e0;
  border-radius: 4px;

  flex: none;
  order: 0;
  flex-grow: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  color: var(--grey700);
  cursor: pointer;

  ${(props) =>
    !!props.isActive &&
    css`
      background: var(--grey200);
      font-weight: 500;
    `};
`;

const SoFormLoadsType = ({ className, load }) => {
  const stepsApi = useSoFormStepsApi();
  const { t } = useTranslation('Catalog');

  return (
    <div className={className}>
      <LoadTypeSelector
        isActive={load.load_type === 'PALLET'}
        onClick={() => {
          if (load.load_type === 'PALLET') return;
          stepsApi.setLoadType({ load, value: 'PALLET' });
        }}
      >
        {t('configuration.loads.palletized')}
      </LoadTypeSelector>
      <LoadTypeSelector
        isActive={load.load_type !== 'PALLET'}
        onClick={() => {
          if (load.load_type !== 'PALLET') return;
          stepsApi.setLoadType({ load, value: 'PARCEL' });
        }}
      >
        {t('configuration.loads.non_palletized')}
      </LoadTypeSelector>
    </div>
  );
};

SoFormLoadsType.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  box-sizing: border-box;
  border: none;
  flex: none;
  order: 0;
  flex-grow: 0;
  display: flex;
  width: 100%;
`;

export default styled(SoFormLoadsType)`
  ${regularCSS}
`;
